import {AbModalConfigInterface} from "@/scripts/modules/ab-modal/ab-modal.types";
import {createDomElementHandler} from "@/scripts/utils/dom.utils";
import AbModalService from "@/scripts/modules/ab-modal/ab-modal.service";
import {AbModalElement} from "@/scripts/modules/ab-modal/component/abModal.element";

export class AbModal {

  private _modalService = AbModalService;

  #element: AbModalElement;
  id : string;

  isOpen: boolean = false;

  private config: AbModalConfigInterface;

  public get handleBackBrowser(): boolean {
    return !!this.config?.handleBackBrowser;
  }

  public get hideBodyOverflow(): boolean {
    return !!this.config?.hideBodyOverflow;
  }

  public onOpen(): void {
    this.isOpen = true
    this.config.handlers?.onOpen?.()
  }

  public onClose(): void {
    this.isOpen = false;
    this.config.handlers?.onClose?.();
  }

  constructor(
    config: AbModalConfigInterface,
    content: DocumentFragment | HTMLElement
  ) {
    this.config = config;
    this.id = this.getUniqueId();

    const attributes = JSON.stringify( config.attributes );
    this.#element = createDomElementHandler(
      'ab-modal',
      [],
      { attributes, id: this.id }
    ) as AbModalElement;
    this.#element.appendChild(content);
    this._modalService.registerModal(this);
    return this;
  }

  public updateTitle(title: string): void {
    this.#element.setTitle(title);
  }

  public updateSizing(sizingClass: string): void {
    this.#element.setSizingClass(sizingClass);
  }

  public show(): void {
    document.body.appendChild(this.#element);
  }

  public hide(): void {
    this.#element.remove();
  }

  private getUniqueId(): string {

    const idFromConfig = (this.config?.id ?? 'modal')
      .trim()
      .replace(/\s+/g, '-');

    if(idFromConfig && this._modalService.isIdAvailable(idFromConfig)) {
      return idFromConfig;
    }

    return `${idFromConfig}-${Math.random().toString(36).substring(2, 15)}`;
  }

}
